import(/* webpackMode: "eager" */ "/opt/fructidor/fructidor-ui/releases/20250705083029/app/[lng]/error.tsx");
